
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/toolpad-use-cases",
      function () {
        return require("private-next-pages/blog/toolpad-use-cases.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/toolpad-use-cases"])
      });
    }
  